import { type NotificationMapper } from 'common/header/notifications/Notifications.types';

export const pingMapper: NotificationMapper = (notification, options) => {
  return {
    ...notification,
    title: options.intl.pingTitle
  };
};
